import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '../services/users.service';
import { LoadingService } from './../../../core/services/loader.service';
import { ActivatedRoute } from '@angular/router';
import { LoginComponent } from '../login/login.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { LoginOtpComponent } from '../login-otp/login-otp.component';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss'],
})
export class UpdatePasswordComponent implements OnInit {
  applicationForm: FormGroup;
  contactId: any;
  submitted = false;
  hide = true;
  hide2 = true;
  constructor(
    private formBuilder: FormBuilder,
    private userService: UsersService,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    public dialog: MatDialog,
    public auth: AuthenticationService
  ) {}
  headerStatus = 'Reset';
  ngOnInit(): void {
    this.checkCurrentURl();
    this.route.params.subscribe((params) => {
      this.contactId = params.contactId;
    });

    this.applicationForm = this.formBuilder.group(
      {
        password: ['', [Validators.required, Validators.maxLength(15)]],
        confirm_password: ['', [Validators.required, Validators.maxLength(15)]],
      },
      { validators: this.checkPasswords }
    );
  }
  checkCurrentURl() {
    // const currentUrl = this.router.url.split('?')[0];
    const currentUrl = this.auth.getCurrentUrl();

    if (currentUrl.includes('update-password')) {
      this.headerStatus = 'Reset';
    } else if (currentUrl.includes('create-password')) {
      this.headerStatus = 'Create';
    }
  }
  checkPasswords(group: FormGroup) {
    // here we have the 'passwords' group
    const password = group.get('password').value;
    const confirmPassword = group.get('confirm_password').value;

    return password === confirmPassword ? null : { notSame: true };
  }
  get applicationF() {
    return this.applicationForm.controls;
  }

  onSubmit() {
    this.submitted = true;

    if (this.applicationForm.invalid) {
      if (this.applicationForm.errors.notSame) {
        this.auth.showSnackBarMsg('Password did not match!');
      }
      return;
    }

    if (this.applicationForm.valid) {
      this.applicationForm.value.contactId = this.contactId;
      this.loadingService.startLoading();
      this.userService.updatePasssword(this.applicationForm.value).subscribe(
        (response) => {
          this.loadingService.stopLoading();

          if (response.success) {
            this.auth.showSnackBarMsg('Password Updated!');
            if (
              this.route.snapshot.queryParams.oppid &&
              this.route.snapshot.queryParams.email
            ) {
              // this.auth.gotoUrl(`/`, {
              //   oppid: this.route.snapshot.queryParams.oppid,
              // });
              this.openDialog(
                'LOGIN TO YOUR ACCOUNT',
                true,
                this.route.snapshot.queryParams.email
              );
            } else {
              // this.auth.gotoUrl('/');
              this.openDialog('LOGIN TO YOUR ACCOUNT');
            }
            window.scroll(0, 0);
          } else {
          }
        },
        (err) => {
          this.loadingService.stopLoading();
          console.log(err);
        }
      );
    }
  }

  openDialog(headline: string, disableEmail = false, email?: string) {
    const dialogRef = this.dialog.open(LoginComponent, {
      width: '500px',
      data: {
        headline,
        disableEmail,
        email,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result == 'forgotPassword') {
          this.openForgotDialog();
        } else if (result == 'otpLogin') {
          this.loginOtp();
        } else if (result == 'onRegister') {
        }
      }
    });
  }

  loginOtp() {
    const dialogRef = this.dialog.open(LoginOtpComponent, {
      width: '500px',
      data: {},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result == 'backToLogin') {
          this.openDialog('LOGIN TO YOUR ACCOUNT');
        } else if (result == 'forgotPassword') {
          this.openForgotDialog();
        } else if (result == 'onRegister') {
        }
      }
    });
  }
  openForgotDialog() {
    const dialogRef = this.dialog.open(ForgotPasswordComponent, {
      width: '500px',
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (result == 'backToLogin') {
          this.openDialog('LOGIN TO YOUR ACCOUNT');
        }
      }
    });
  }
}
